export default "__VITE_ASSET__BKDr0xEX__"